<div class="dashboard-container display-flex flex-column" [ngClass]="containerCss">
  <ng-container
    [ngTemplateOutlet]="
      loading
        ? spinnerTemplate
        : emptyDashboard
        ? customEmptyDashboardTemplate || emptyDashboardTemplate
        : contentTemplate
    "
  ></ng-container>
</div>

<ng-template #contentTemplate>
  <div class="header">
    <ng-content select="[header]"></ng-content>
  </div>
  <div class="body" [ngClass]="bodyCss" (scroll)="onBodyScroll($event)">
    <ng-content select="[body]"></ng-content>
  </div>
  <div class="footer" [class.sticky-footer]="stickyFooter">
    <ng-content select="[footer]"></ng-content>
  </div>
</ng-template>

<ng-template #spinnerTemplate>
  <div class="spinner-container">
    <app-animation [animationItem]="Animation.BLACK_LOGO"></app-animation>
  </div>
</ng-template>

<ng-template #emptyDashboardTemplate>
  <app-empty-dashboard></app-empty-dashboard>
</ng-template>
